<template>
  <main id="container" class="store_st">
    <!-- 학기 이벤트 팝업 -->
    <MainPopup v-if="!getCurrentUser" />
    <!-- // 학기 이벤트 팝업 -->
    <!-- <Sidebar /> -->
    <!-- 메인 이벤트 베너 -->
    <section class="store_slider_wrap">
      <swiper :options="swiperOptionsBanner" class="swiper">
        <swiper-slide
          v-for="(slide, idx) in getBanners"
          :key="idx"
          style="cursor: pointer;"
          :style="{ 'background-color': `${slide.bannerColor}` }"
        >
          <a class="slide_item" :href="slide.linkUrl">
            <img
              :src="slide.bannerUrl"
              :loading="idx === 5 ? 'eager' : 'lazy'"
              :fetchpriority="idx === 5 ? 'high' : 'auto'"
              alt="이벤트 이미지"
            />
          </a>
        </swiper-slide>
      </swiper>
      <div class="pagenation_wrap">
        <div class="swiper-pagination"></div>
      </div>
    </section>
    <ul v-if="deviceTp === 'WEB' || deviceTp === 'PAD'" class="sort_tab_wrap">
      <li class="tab_item" @click="scrollToEbook">
        eBook ONLY
      </li>
      <li class="tab_item" @click="scrollToBestnew('popular')">
        베스트셀러
      </li>
      <li class="tab_item" @click="scrollToBestnew('new')">
        신간도서
      </li>
    </ul>
    <ul v-if="deviceTp === 'MO'" class="section_tab">
      <li class="tab_list" @click="scrollToEbook">
        <div>
          <img src="@/assets/images/mobile_main/ebook.png" alt="ebook" />
        </div>
        <span class="bottom_text">eBook ONLY</span>
      </li>
      <li class="tab_list" @click="scrollToBestnew('popular')">
        <div>
          <img src="@/assets/images/mobile_main/best.png" alt="베스트 셀러" />
        </div>
        <span class="bottom_text">베스트셀러 </span>
      </li>
      <li class="tab_list" @click="scrollToBestnew('new')">
        <div>
          <img src="@/assets/images/mobile_main/new.png" alt="신간도서" />
        </div>
        <span class="bottom_text">신간도서 </span>
      </li>
    </ul>
    <!-- 우리학교는 -->
    <section class="my_college_wrap">
      <div class="book_wrap inner_wrapping list_slide_wrap">
        <h2 class="title">
          <div v-if="nonCollege === false" class="ani_wrap">
            <strong class="seoul">지금 서울대학교는</strong>
            <strong class="korea">지금 고려대학교는</strong>
            <strong class="yeon">지금 연세대학교는</strong>
            <strong class="seogang">지금 서강대학교는</strong>
            <strong class="hanyang">지금 한양대학교는</strong>
          </div>
          <div v-else class="no_ani">
            <strong class="mycollege">
              {{ getCurrentUser.unicolNm }}에선
            </strong>
          </div>
          <span>어떤 책을 선택했을까?</span>
        </h2>
        <swiper
          v-if="getUnicolBooksList"
          :ref="`choiceSwiper${0}`"
          :options="swiperOptionsBook"
          class="book_list college"
          :class="
              (
              getCurrentUser && getCurrentUser.unicolNm && getCurrentUser.unicolNm !== '기타' ? 'college_on' : '')
            "
        >
          <BaseCollegeBook
            v-for="(book, i) in getUnicolBooksList"
            v-show="i < 15"
            :key="`${i}_book_store`"
            class="swiper-slide"
            :class="{ store_line: i % 5 === 0 && i < 15 && i > 3 }"
            :book="book"
          />
        </swiper>
        <div
          v-if="
            !getCurrentUser ||
            (getCurrentUser &&
              (!getCurrentUser.unicolNm || getCurrentUser.unicolNm === '기타'))
          "
          class="chk_college"
        >
          <p>아직 입력된 대학교가 없습니다</p>
          <p>대학교를 등록하면 학교도서를 볼 수 있습니다</p>
          <button class="college_registration" @click="toggleCollegePutModal">
            학교 등록하기
          </button>
        </div>
      </div>
    </section>
    <!-- ebook Only -->
    <section ref="ebookSection" class="ebook_sec">
      <div class="inner_wrapping">
        <div class="title">
          <h2>e-Book ONLY</h2>
          <router-link to="/store/books/category/ebook">더보기</router-link>
        </div>
        <swiper
          v-if="getEbookOnlyList"
          ref="swiper1"
          :options="swiperOptionsEBook1"
          class="ebook_list"
        >
          <BaseEbookOnly
            v-for="(book, i) in getEbookOnlyList"
            v-show="i < 15"
            :key="`${i}_book_store`"
            class="swiper-slide"
            :book="book"
          />
        </swiper>
        <swiper
          v-if="getEbookOnlyList"
          ref="swiper2"
          :options="swiperOptionsEBook2"
          class="ebook_list_text"
        >
          <swiper-slide
            v-for="(book, i) in getEbookOnlyList"
            v-show="i < 15"
            :key="`${i}_book_store`"
            class="swiper-slide"
            :book="book"
          >
            <div class="text_wrap">
              <cite>{{ book.bookNm }}</cite>
              <span>{{ book.author }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </section>
    <!-- 이벤트 배너 -->
    <section class="event_banner_section new_f_banner">
      <div class="inner_wrapping">
        <swiper :options="swiperOptionsEventBanner" class="swiper">
          <swiper-slide
            v-for="(eSlide, i) in getEventBanners"
            :key="i"
            style="cursor: pointer;"
          >
            <a class="slide_item foot_slide" :href="eSlide.linkUrl"
              ><img :src="eSlide.bannerUrl" :alt="altTexts[i]"
            /></a>
          </swiper-slide>
        </swiper>
      </div>
    </section>
    <!-- 베스트/신간 Pc -->
    <section
      v-if="deviceTp === 'WEB' || deviceTp === 'PAD'"
      ref="bestNewSectionPc"
      class="best_new"
    >
      <div class="inner_wrapping list_slide_wrap">
        <div class="head_flex">
          <h2 class="topic_wrap">
            <button
              class="topic_best"
              :class="bestNewTab === 'popular' ? 'active_tab_book' : ''"
              @click="bestNewBook('popular')"
            >
              베스트셀러
            </button>
            <button
              class="topic_new"
              :class="bestNewTab === 'new' ? 'active_tab_book' : ''"
              @click="bestNewBook('new')"
            >
              신간도서
            </button>
          </h2>
          <button class="pc_more_btn" @click="goBookMore">
            더보기
          </button>
        </div>
        <swiper
          v-if="getMain"
          :ref="`choiceSwiper${1}`"
          class="bestnew_list"
          :options="swiperOptionsBestNew"
        >
          <div
            v-for="(book, i) in getMain[bestNewTab]"
            v-show="i < 14"
            :key="`${i}_book_store`"
            :class="{ store_line: i % 5 === 0 && i < 15 && i > 3 }"
            :book="book"
            class="swiper-slide"
          >
            <div class="num_wrap">
              <span class="num">{{ i + 1 }}</span>
              <span v-if="book.ebookOnly === 'Y'" class="ebook_tag"
                >e-Book ONLY</span
              >
            </div>
            <router-link
              :to="{
                name: `book_detail`,
                params: { id: book.bookCd || book.id, orderId: book.orderId }
              }"
              class="book_link"
              :data-num="i + 1"
            >
              <figure>
                <img :src="book.img" :alt="book.title" />
                <figcaption>
                  <cite class="prod_name">{{ book.title }}</cite>
                  <span class="prod_author">{{ book.author }}</span>
                  <!-- <span v-if="book.ebookOnly === 'Y'" class="ebook_only"
                      >e-book ONLY</span
                    > -->
                </figcaption>
              </figure>
            </router-link>
          </div>
        </swiper>
      </div>
    </section>
    <!-- 베스트/신간 Mobile -->
    <section v-else ref="bestNewSectionMo" class="best_new bg">
      <h2 class="topic_wrap">
        <button
          class="topic_best"
          :class="bestNewTab === 'popular' ? 'active_tab_book' : ''"
          @click="bestNewBook('popular')"
        >
          베스트셀러
        </button>
        <button
          class="topic_new"
          :class="bestNewTab === 'new' ? 'active_tab_book' : ''"
          @click="bestNewBook('new')"
        >
          신간도서
        </button>
      </h2>
      <ul v-if="getMain" class="bestnew_list">
        <li
          v-for="(book, i) in getMain[bestNewTab]"
          v-show="i < 3"
          :key="`${i}_book_store`"
          :class="{ store_line: i % 5 === 0 && i < 15 && i > 3 }"
          :book="book"
        >
          <router-link
            :to="{
              name: `book_detail`,
              params: { id: book.bookCd || book.id, orderId: book.orderId }
            }"
            class="book_link"
            :data-num="i + 1"
          >
            <figure>
              <div>
                <img :src="book.img" :alt="book.title" />
              </div>
              <figcaption>
                <cite class="prod_name">{{ book.title }}</cite>
                <span class="prod_author">{{ book.author }}</span>
                <span v-if="book.ebookOnly === 'Y'" class="ebook_only"
                  >e-Book ONLY</span
                >
              </figcaption>
            </figure>
          </router-link>
        </li>
      </ul>
      <button class="more_btn" @click="goBookMore">
        더보기
      </button>
    </section>
    <!-- 카테고리 도서 -->
    <section class="catagory_wrap">
      <div class="inner_wrapping list_slide_wrap">
        <div class="list_info">
          <h2 class="title">카테고리별 도서</h2>
          <ul
            ref="slider"
            class="catagory_list"
            @mousedown="onMouseDown"
            @mouseleave="onMouseLeave"
            @mouseup="onMouseUp"
          >
            <li
              v-for="(catagorySlide, i) in getMainCategories"
              v-show="i > 0"
              :key="i"
              :class="{ active: activeIndex === i }"
              @click="setActive(i)"
              @mouseup="preventSelection"
              @mousedown="preventSelection"
            >
              {{ catagorySlide.catgryNm }}
            </li>
          </ul>
        </div>
        <swiper
          v-if="getCategoryBooksList"
          :ref="`choiceSwiper${2}`"
          :options="swiperOptionsCatagory"
          class="catagory_slide_wrap"
        >
          <BaseGenre
            v-for="(book, i) in getCategoryBooksList"
            v-show="i < 15"
            :key="`${i}_book_store`"
            class="swiper-slide"
            :book="book"
          />
          <div class="swiper-slide special-slide">
            <router-link
              :to="`/store/${moreCatagory}/books/${moreCatagory}`"
              class="more_plus"
            >
              더보기
            </router-link>
          </div>
        </swiper>
      </div>
    </section>
    <section
      v-for="(books, categoryKey, index) in getGenre"
      :key="categoryKey"
      class="swiper_section"
    >
      <div class="inner_wrapping list_slide_wrap">
        <div class="list_info">
          <h2 class="title">{{ getCategoryTitle(categoryKey) }}</h2>
        </div>
        <swiper
          :ref="`choiceSwiper${index + 3}`"
          :options="swiperOptionsCatagory"
          :class="`${getCategoryClass(categoryKey)}_slide_wrap`"
        >
          <BaseGenre
            v-for="(book, i) in books"
            :key="`${i}_book_store`"
            class="swiper-slide"
            :book="book"
          />
        </swiper>
      </div>
    </section>
    <!-- Helpdesk -->
    <!-- <HelpDesk /> -->
    <div class="ftnav_wrap" :class="{ 'down': !isVisible }">
      <nav class="docker_wrapper">
        <a href="/">
          <img src="@/assets/images/mobile_main/home.png" alt="메인" />
        </a>
        <router-link to="/cart">
          <img src="@/assets/images/mobile_main/cart.png" alt="장바구니" />
        </router-link>
        <router-link to="/account">
          <img src="@/assets/images/mobile_main/person.png" alt="계정" />
        </router-link>
        <i class="ft_hamicon" @click="openMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </i>
      </nav>
    </div>
    <transition name="modal-fade">
      <MobileSidebar
        v-if="showMobileMenu"
        :class="{ 'show-mobile-menu': showMobileMenu }"
        @close="closeMobileMenu"
      />
    </transition>
    <!-- 학교등록하기 -->
    <transition v-on-clickaway="toggleCollegePutModal" name="modal-fade">
      <Modal v-if="showCollegePutModal" @close="toggleCollegePutModal">
        <div class="ly_pop_wrap college_put">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCollegePutModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <div class="cart_desc_wrap">
                  <div class="cart_desc_head">
                    <span class="star">*</span> 고객님의 <br />
                    <span class="line_bottom">학교를 선택해 주세요.</span>
                  </div>
                  <div class="cart_desc_body">
                    <div class="put_wrap">
                      <input
                        id="unicol"
                        v-model="unicolNm"
                        class="input_t put_college"
                        name="unicol"
                        placeholder="학교를 선택해 주세요"
                        readonly="readonly"
                        @click="toggleUnicolModal"
                      />
                      <button class="college_search" @click="toggleUnicolModal">
                        검색
                      </button>
                    </div>
                    <p class="because">
                      ※마케팅 정보 수신 동의는 계정 설정을 통해 언제든지
                      변경(동의/철회) 하실 수 있습니다.
                    </p>
                  </div>
                </div>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="updateCollege">
                  확인
                </button>
              </div>
            </div>
            <unicolModal
              v-if="isShowUnicol"
              @close="toggleUnicolModal"
              @unicolInfo="selectUnicol"
            />
          </div>
        </div>
      </Modal>
    </transition>
  </main>
</template>
<script>
import MainPopup from '../../components/popup/MainPopup.vue'
import BaseCollegeBook from '@/components/base/BaseCollegeBook.vue'
import BaseGenre from '@/components/base/BaseGenre.vue'
import unicolModal from '@/components/library/unicolModal.vue'
// import HelpDesk from '@/components/common/HelpDesk.vue'
import MobileSidebar from '@/components/common/MobileSidebar.vue'
import swiperSettings from '@/data/swiperSettings'
import { mapGetters } from 'vuex'
import {
  hideSelfbook,
  ysHeaderText,
  hideCategories,
  hakji,
  isKhu
} from '@/store/constants'
import {
  STORE_MAIN_GET,
  EBOOK_ONLY_LIST,
  CATEGORY_BOOKS_LIST,
  ACCOUNT_UPDATE_UNICOL,
  AUTH_REFRESH,
  UNICOL_BOOKS_LIST,
  GENRE_BOOK_LIST,
  GENRE_LIST
} from '@/store/types'

export default {
  name: 'Store',
  components: {
    // HelpDesk,
    MobileSidebar,
    unicolModal,
    BaseCollegeBook,
    MainPopup,
    BaseGenre
    // QuickNav
  },
  data() {
    return {
      isKhu,
      hakji,
      hideSelfbook,
      ysHeaderText,
      hideCategories,
      ...swiperSettings,
      search: '',
      selectTab: 'new',
      bestNewTab: 'popular',
      window: {
        width: 0
      },
      altTexts: ['인스타그램', '블로그', '베스트셀러'],
      isSyncing: false, // 동기화 상태를 나타내는 플래그
      firstSlideChangeHandled: false, // 첫 슬라이드 이동을 처리했는지 여부
      activeIndex: 1,
      isVisible: true, // 요소의 초기 가시성 상태
      lastScrollPosition: 0, // 마지막 스크롤 위치를 추적하기 위한 변수
      showMobileMenu: false,
      moreCatagory: '00310081',
      showCollegePutModal: false,
      isShowUnicol: false,
      unicolCd: '',
      unicolNm: '',
      nonCollege: false,
      // 카테고리 스크롤
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      genreNames: []
    }
  },
  computed: {
    ...mapGetters([
      'getMain',
      'getMainCategories',
      'isMainLoading',
      'isMainCategoriesLoading',
      'getCurrentUser',
      'getPreparedTrialCode',
      'getPreparedBookfairTrialCode',
      'getEbookOnlyList',
      'getCategoryBooksList',
      'getUnicolBooksList',
      'getGenre',
      'getGenreMap',
      'getPreparedClaimCode',
      'getPreparedClaimType'
    ]),
    slideList() {
      return [1, 2, 3, 4]
    },
    deviceTp() {
      if (1024 < this.window.width) {
        return 'WEB'
      }
      if (481 < this.window.width) {
        return 'PAD'
      }
      // if (1024 < this.window.width) return 'WEB'
      return 'MO'
    },
    getBanners() {
      return this.getMain?.banners.find((e) => e.deviceTp === this.deviceTp)
        ?.url
    },
    getEventBanners() {
      return this.getMain?.eventBanners.find(
        (e) => e.deviceTp === this.deviceTp
      )?.url
    }
  },
  watch: {
    getCurrentUser: {
      handler() {
        this.$nextTick(() => {
          this.listSwipers()
        })
      },
      deep: true
    },
    getEbookOnlyList: {
      handler() {
        this.$nextTick(() => {
          this.ebookSwiper()
        })
      },
      deep: true
    },
    getCategoryBooksList: {
      handler() {
        this.$nextTick(() => {
          this.listSwipers()
        })
      },
      deep: true
    }
  },
  async mounted() {
    // 윈도우 이벤트 리스너
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    window.addEventListener('scroll', this.handleScroll)

    // 병렬로 여러 dispatch 실행
    try {
      await this.$store.dispatch(STORE_MAIN_GET)
      await this.delay(100) // 100ms 대기

      await this.fetchGenreList() // 장르 타이틀 이름만
      await this.fetchAndProcessGenres() // 장르 도서 리스트

      await Promise.all([
        this.$store.dispatch(EBOOK_ONLY_LIST, {
          pageNo: 1,
          pageRow: 15
        })
      ])
      // 유저 관련 처리
      const userUnicolCd = this.getCurrentUser?.unicolCd
      if (userUnicolCd) {
        await this.$store.dispatch(UNICOL_BOOKS_LIST, {
          unicolCode: userUnicolCd
        })
      } else {
        await this.$store.dispatch(UNICOL_BOOKS_LIST, {
          unicolCode: userUnicolCd
        })
      }

      if (this.getMainCategories?.length > 1) {
        const initialCategoryCode = this.getMainCategories[1].catgryCd
        this.activeIndex = 1
        this.moreCatagory = initialCategoryCode

        await this.$store.dispatch(CATEGORY_BOOKS_LIST, {
          categoryCode: initialCategoryCode
        })
      }
    } catch (error) {
      // console.error('데이터 로드 중 오류 발생:', error)
    }
  },
  updated() {
    if (this.getCurrentUser && this.getPreparedTrialCode) {
      this.$router.push({
        name: 'trial',
        params: { code: this.getPreparedTrialCode }
      })
    }
    if (this.getCurrentUser && this.getPreparedBookfairTrialCode) {
      this.$router.push({
        name: 'trial_bookfair',
        params: { code: this.getPreparedBookfairTrialCode }
      })
    }
    if (this.getCurrentUser && this.getPreparedClaimCode) {
      this.$router.push({
        name: 'Claim',
        params: { type: this.getPreparedClaimType },
        query: { code: this.getPreparedClaimCode }
      })
    }
    this.checkUnicolStatus()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 카테고리 제목 가져오기 - 최적화됨
    getCategoryTitle(categoryKey) {
      const categories = Object.keys(this.getGenre)
      const index = categories.indexOf(categoryKey)
      return index !== -1 && this.genreNames[index]
        ? this.genreNames[index]
        : '기본 카테고리'
    },
    // 장르 목록 가져오기
    async fetchGenreList() {
      try {
        await this.$store.dispatch(GENRE_LIST)
      } catch (error) {
        console.error('장르 목록 가져오기 오류:', error)
      }
    },
    // 장르 정보 가져오기 및 처리
    async fetchAndProcessGenres() {
      const list = this.getGenreMap
      if (!list || !list.length) return

      this.genreNames = list.map((item) => item.name.replace('추천-', ''))

      const genreTypes = list.map((item) => item.type)

      try {
        for (const type of genreTypes) {
          try {
            await this.$store.dispatch(GENRE_BOOK_LIST, { type })
          } catch (typeError) {
            console.error(`${type} 장르 도서 목록 가져오기 오류:`, typeError)
          }
        }
      } catch (error) {
        console.error('장르 도서 목록 가져오기 오류:', error)
      }
    },
    // 카테고리 CSS 클래스 이름 가져오기
    getCategoryClass(categoryKey) {
      return `category_${categoryKey.toLowerCase().replace('_', '-')}`
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    checkUnicolStatus() {
      if (this.getCurrentUser && this.getCurrentUser.unicolNm !== undefined) {
        this.nonCollege = true
      } else {
        this.nonCollege = false
      }
    },
    locationUrl(link) {
      window.location.href = link
    },
    handleResize() {
      this.window.width = window.innerWidth
    },
    sortByBook(tab) {
      this.selectTab = tab
    },
    bestNewBook(tab) {
      this.bestNewTab = tab
    },
    goMoreBook() {
      this.$router.push({
        name: 'books_category',
        params: {
          category: this.selectTab
        }
      })
    },
    goBookMore() {
      this.$router.push({
        name: 'books_category',
        params: {
          category: this.bestNewTab
        }
      })
    },
    ebookSwiper() {
      // ebook만 따로
      const swiper1 = this.$refs.swiper1 ? this.$refs.swiper1.$swiper : null
      const swiper2 = this.$refs.swiper2 ? this.$refs.swiper2.$swiper : null
      const ebookList = document.querySelector('.ebook_sec > .inner_wrapping')
      const nextButton = document.createElement('button')
      const prevButton = document.createElement('button')
      nextButton.classList.add('swiper-button-next')
      prevButton.classList.add('swiper-button-prev')
      ebookList.append(nextButton, prevButton)
      swiper1.on('transitionEnd', () => {
        if (!this.firstSlideChangeHandled) {
          swiper2.slideToLoop(swiper1.realIndex, 300, true)
          this.firstSlideChangeHandled = true
        } else {
          if (this.isSyncing) return
          this.isSyncing = true
          swiper2.slideToLoop(swiper1.realIndex, 300, true)
          this.isSyncing = false
        }
      })
      if (window.innerWidth > 480) {
        nextButton.addEventListener('click', () => {
          swiper1.slideNext() // 다음 슬라이드로 이동
          swiper2.slideNext() // 다음 슬라이드로 이동
        })
        prevButton.addEventListener('click', () => {
          swiper1.slidePrev() // 이전 슬라이드로 이동
          swiper2.slidePrev() // 이전 슬라이드로 이동
        })
      } else {
        nextButton.style.display = 'none'
        prevButton.style.display = 'none'
      }
    },
    listSwipers() {
      this.$nextTick(() => {
        const listSlideWraps = document.querySelectorAll('.list_slide_wrap')

        listSlideWraps.forEach((listSlideWrap, index) => {
          // 1. 이전 버튼 제거 후 새로 생성
          const existingNext = listSlideWrap.querySelector(
            '.swiper-button-next'
          )
          const existingPrev = listSlideWrap.querySelector(
            '.swiper-button-prev'
          )
          if (existingNext) existingNext.remove()
          if (existingPrev) existingPrev.remove()

          const nextButton = document.createElement('button')
          nextButton.classList.add('swiper-button-next')
          const prevButton = document.createElement('button')
          prevButton.classList.add('swiper-button-prev')
          listSlideWrap.append(nextButton, prevButton)

          // 2. Swiper 인스턴스 가져오기
          const refIndex = index
          const swiperRef = this.$refs[`choiceSwiper${refIndex}`]
          let choiceSwiper = null

          if (swiperRef) {
            if (swiperRef.$swiper) choiceSwiper = swiperRef.$swiper
            else if (swiperRef.swiperInstance)
              choiceSwiper = swiperRef.swiperInstance
            else if (swiperRef.swiper) choiceSwiper = swiperRef.swiper
          }

          // 인스턴스를 찾을 수 없으면 DOM에서 직접 찾기
          if (!choiceSwiper) {
            const swiperElement =
              listSlideWrap.querySelector('.swiper-container') ||
              listSlideWrap.querySelector('.swiper-wrapper')?.parentNode
            if (swiperElement && swiperElement.swiper) {
              choiceSwiper = swiperElement.swiper
            }
          }

          // Swiper 인스턴스가 없으면 처리 중단
          if (!choiceSwiper) {
            console.warn(`Swiper instance not found for index ${refIndex}`)
            return
          }

          // 3. my_college_wrap 처리 (필요시)
          if (
            this.nonCollege === false &&
            listSlideWrap.closest('.my_college_wrap')
          ) {
            nextButton.style.display = 'none'
            prevButton.style.display = 'none'
          }

          // 4. 버튼 상태 업데이트 함수
          const updateButtonDisplay = () => {
            if (window.innerWidth <= 480) {
              prevButton.style.display = 'none'
              nextButton.style.display = 'none'
              return
            }

            prevButton.style.display = choiceSwiper.isBeginning
              ? 'none'
              : 'block'
            nextButton.style.display = choiceSwiper.isEnd ? 'none' : 'block'
          }

          // 5. 버튼 클릭 이벤트 핸들러
          nextButton.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            choiceSwiper.slideNext()

            // 강제 상태 업데이트
            setTimeout(() => {
              prevButton.style.display = 'block' // 다음 버튼 클릭 후에는 항상 이전 버튼 표시
              nextButton.style.display = choiceSwiper.isEnd ? 'none' : 'block'
            }, 100)
          })

          prevButton.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            choiceSwiper.slidePrev()

            // 강제 상태 업데이트
            setTimeout(() => {
              prevButton.style.display = choiceSwiper.isBeginning
                ? 'none'
                : 'block'
              nextButton.style.display = 'block' // 이전 버튼 클릭 후에는 항상 다음 버튼 표시
            }, 100)
          })

          // 6. Swiper 이벤트 리스너 설정 (기존 리스너 제거 후)
          choiceSwiper.off('slideChange transitionEnd')

          // 슬라이드 변경 시 버튼 상태 업데이트
          choiceSwiper.on('slideChange', updateButtonDisplay)
          choiceSwiper.on('transitionEnd', updateButtonDisplay)

          // 7. 초기 상태 설정 및 리사이즈 핸들러
          updateButtonDisplay()

          const resizeHandler = () => {
            if (choiceSwiper && typeof choiceSwiper.update === 'function') {
              choiceSwiper.update()
            }
            updateButtonDisplay()
          }

          window.removeEventListener('resize', resizeHandler)
          window.addEventListener('resize', resizeHandler)
        })
      })
    },
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      // 스크롤 방향을 비교하여 요소의 가시성을 제어
      if (currentScrollPosition > this.lastScrollPosition) {
        // 스크롤을 내릴 때 (Down)
        this.isVisible = false
      } else {
        // 스크롤을 올릴 때 (Up)
        this.isVisible = true
      }
      // 현재 스크롤 위치를 업데이트
      this.lastScrollPosition =
        currentScrollPosition <= 0 ? 0 : currentScrollPosition
    },
    openMobileMenu() {
      this.showMobileMenu = true
    },
    closeMobileMenu() {
      this.showMobileMenu = false
    },
    scrollToEbook() {
      this.$nextTick(() => {
        const ebook = this.$refs.ebookSection
        if (ebook) {
          const currentScrollPosition = window.pageYOffset
          const additionalOffset = currentScrollPosition > 0 ? -100 : -100
          const offset =
            ebook.getBoundingClientRect().top +
            window.pageYOffset +
            additionalOffset
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    },
    scrollToBestnew(tab) {
      this.bestNewTab = tab
      this.$nextTick(() => {
        let bestNew
        if (this.deviceTp === 'WEB' || this.deviceTp === 'PAD') {
          bestNew = this.$refs.bestNewSectionPc
        } else if (this.deviceTp === 'MO') {
          bestNew = this.$refs.bestNewSectionMo
        }

        if (bestNew) {
          const currentScrollPosition = window.pageYOffset
          const additionalOffset =
            window.innerWidth >= 480
              ? currentScrollPosition > 0
                ? -98
                : -98
              : currentScrollPosition > 0
              ? -40
              : -100
          const offset =
            bestNew.getBoundingClientRect().top +
            window.pageYOffset +
            additionalOffset
          window.scrollTo({ top: offset, behavior: 'smooth' })
        }
      })
    },
    toggleUnicolModal() {
      this.isShowUnicol = !this.isShowUnicol
    },
    toggleCollegePutModal() {
      if (this.getCurrentUser === null) {
        this.$router.push({ name: 'login' })
      } else {
        this.showCollegePutModal = !this.showCollegePutModal
      }
    },
    selectUnicol(school) {
      if (!school) {
        this.toggleUnicolModal()
        return
      }
      this.toggleUnicolModal()
      this.unicolNm = school.unicolNm
      this.unicolCd = school.unicolCd
    },
    async updateCollege() {
      if (!this.unicolNm) {
        alert('학교를 선택해주세요.')
        return
      }
      try {
        await this.$store.dispatch(ACCOUNT_UPDATE_UNICOL, {
          unicolCode: this.unicolCd
        })
        await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        alert('오류가 발생했습니다.')
      } finally {
        this.showCollegePutModal = false // 모달 닫기
      }
    },
    setActive(index) {
      if (!this.isDown) {
        // 드래그 중이 아닐 때만 실행
        this.activeIndex = index
        const selectedCategoryCode = this.getMainCategories[index].catgryCd
        this.moreCatagory = selectedCategoryCode
        this.$store.dispatch(CATEGORY_BOOKS_LIST, {
          categoryCode: selectedCategoryCode
        })
      }
    },
    // 카테고리 스크롤
    preventSelection(e) {
      e.preventDefault() // 기본 선택 방지
    },
    onMouseDown(e) {
      this.isDown = true
      this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.scrollLeft = this.$refs.slider.scrollLeft
      document.body.style.userSelect = 'none' // 드래그 중 전체 선택 방지
      window.addEventListener('mousemove', this.onMouseMove)
      window.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove(e) {
      if (!this.isDown) return
      const x = e.pageX - this.$refs.slider.offsetLeft
      const walk = x - this.startX
      this.$refs.slider.scrollLeft = this.scrollLeft - walk
    },
    onMouseUp() {
      this.isDown = false
      document.body.style.userSelect = '' // 마우스를 뗐을 때 선택 기능 복원
      window.removeEventListener('mousemove', this.onMouseMove)
      window.removeEventListener('mouseup', this.onMouseUp)
    },
    onMouseLeave() {
      if (this.isDown) {
        this.isDown = false
        window.removeEventListener('mousemove', this.onMouseMove)
        window.removeEventListener('mouseup', this.onMouseUp)
      }
    }
  }
}
</script>
<style scoped src="@/assets/css/page_store.css"></style>
<style lang="scss">
#container {
  margin: 0;
}
.swiper img {
  image-rendering: -webkit-optimize-contrast;
  transform: translateZ(0);
  backface-visibility: hidden;
  height: 100%;
}
.swiper .slide_item {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  // background-position: center;
  // background-repeat: no-repeat;
  // background-size: contain;
}
.best_new .swiper-button-prev,
.best_new .swiper-button-next {
  top: 56%;
}
.my_college_wrap .swiper-button-prev,
.ebook_sec .swiper-button-prev,
.best_new .swiper-button-prev,
.catagory_wrap .swiper-button-prev,
.swiper_section .swiper-button-prev {
  background: url('../../assets/images/nav/arrow.png') no-repeat center center;
  width: 40px;
  height: 40px;
  background-size: cover;
  transform: rotate(-180deg);
  left: 0;
  border-radius: 30px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  &::after {
    font-size: 0;
  }
}
.my_college_wrap .swiper-button-next,
.ebook_sec .swiper-button-next,
.best_new .swiper-button-next,
.catagory_wrap .swiper-button-next,
.swiper_section .swiper-button-next {
  background: url('../../assets/images/nav/arrow.png') no-repeat center center;
  width: 40px;
  height: 40px;
  background-size: cover;
  right: 0;
  border-radius: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  &::after {
    font-size: 0;
  }
}
.my_college_wrap .swiper-button-prev,
.my_college_wrap .swiper-button-next {
  top: 53%;
}
.book_list.college_on .swiper-wrapper {
  align-items: flex-end;
}
.ebook_sec .swiper-button-next,
.ebook_sec .swiper-button-prev {
  top: 46%;
}
.ebook_sec .swiper-wrapper {
  align-items: center;
}
.ebook_list_text .swiper-slide:not(.swiper-slide-active) {
  opacity: 0 !important;
}
.best_new .swiper-wrapper {
  align-items: flex-end;
}
.best_new .swiper-slide {
  width: 230px !important;
  max-width: 230px;
}
.best_new .num_wrap {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 15px;
}
.best_new .num_wrap .num {
  width: 35px;
  height: 35px;
  background-color: #6fc8d0;
  border-radius: 10px;
  line-height: 35px;
  text-align: center;
  font-size: 21px;
  color: #fff;
}
.best_new .num_wrap .ebook_tag {
  min-width: 100px;
  height: 35px;
  padding: 8px 14px;
  border: 1px solid #a0a0a0;
  border-radius: 15px;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}
.best_new .swiper-slide::before {
  /* // content: attr(data-num); */
  position: absolute;
  top: -1px;
  left: -1px;
  width: 40px;
  height: 40px;
  background-color: #6fc8d0;
  font-size: 25px;
  text-align: center;
  line-height: 40px;
  color: #fff;
}
.best_new .swiper-slide > a {
  display: block;
  width: 100%;
  height: 415px;
}
.best_new .swiper-slide > a figure {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 18px;
  width: 100%;
  height: 100%;
}
.best_new .swiper-slide > a figure img {
  object-fit: cover;
  max-height: 330px;
  width: 100%;
  aspect-ratio: auto 1 / 1.37;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.2);
}
.best_new .swiper-slide > a figure figcaption {
  min-height: 80px;
  .prod_name {
    width: 209px;
    margin-bottom: 3px;
    letter-spacing: 0.1px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-family: 'pretendard-medium';
    font-size: 16px;
  }
  .prod_author {
    display: block;
    width: 209px;
    line-height: 16px;
    letter-spacing: 0.1px;
    font-size: 14px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.catagory_wrap .swiper-wrapper {
  align-items: flex-end;
}
.catagory_wrap .swiper-button-prev,
.catagory_wrap .swiper-button-next {
  top: 55%;
}
.swiper_section .swiper-wrapper {
  align-items: flex-end;
}
.swiper_section .swiper-button-prev,
.swiper_section .swiper-button-next {
  top: 46%;
}
@media (max-width: 1024px) {
  .my_college_wrap .swiper-button-prev,
  .ebook_sec .swiper-button-prev,
  .best_new .swiper-button-prev,
  .catagory_wrap .swiper-button-prev,
  .swiper_section .swiper-button-prev {
    left: 15px;
  }
  .my_college_wrap .swiper-button-next,
  .ebook_sec .swiper-button-next,
  .best_new .swiper-button-next,
  .catagory_wrap .swiper-button-next,
  .swiper_section .swiper-button-next {
    right: 15px;
  }
  .best_new .swiper-slide {
    width: 184px !important;
  }
  .best_new .swiper-slide > a {
    height: 350px;
  }
  .best_new .num_wrap .num {
    width: 45px;
    height: 45px;
    line-height: 45px;
    font-size: 26px;
  }
  .best_new .swiper-slide > a figure figcaption cite.prod_name {
    width: 184px;
  }
  .best_new .swiper-slide > a figure figcaption cite.prod_author {
    width: 184px;
  }
}
@media (max-width: 768px) {
  .best_new .swiper-slide {
    width: 147px !important;
  }
  .best_new .swiper-slide > a {
    height: 300px;
  }
  .best_new .num_wrap .num {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
  .best_new .num_wrap .ebook_tag {
    padding: 8px 11px;
  }
  .best_new .swiper-slide > a figure figcaption cite.prod_name {
    width: 147px;
    font-size: 14px;
    line-height: 16px;
  }
  .best_new .swiper-slide > a figure figcaption span.prod_author {
    width: 147px;
    line-height: 14px;
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .my_college_wrap .swiper-button-next,
  .ebook_sec .swiper-button-next,
  .best_new .swiper-button-next,
  .catagory_wrap .swiper-button-next,
  .language .swiper-button-next,
  .exam .swiper-button-next,
  .psychology .swiper-button-next,
  .crime .swiper-button-next {
    display: none;
  }
  .my_college_wrap .swiper-button-prev,
  .ebook_sec .swiper-button-prev,
  .best_new .swiper-button-prev,
  .catagory_wrap .swiper-button-prev,
  .language .swiper-button-prev,
  .exam .swiper-button-prev,
  .psychology .swiper-button-prev,
  .crime .swiper-button-prev {
    display: none;
  }
  .store_slider_wrap .swiper-pagination-custom {
    display: flex;
    align-items: center;
    gap: 3px;
    width: 60px;
    left: auto;
    right: 15px;
    bottom: 15px;
    padding: 7px 20px 7px 10px;
    background: #aaaaaa;
    border-radius: 5px;
  }
  .store_slider_wrap .swiper-pagination-custom span {
    font-size: 15px;
    color: #fff;
  }
  .store_slider_wrap .swiper-pagination-next {
    position: absolute;
    background: url('../../assets/images/mobile_main/page_arrow.png') no-repeat;
    background-size: contain;
    width: 28px;
    height: 28px;
    right: -2px;
    bottom: 1px;
  }
  .store_slider_wrap .swiper-slide {
    height: 225px;
  }
  .book_list.college .swiper-slide {
    width: 108px !important;
    max-width: 108px;
  }
  .ebook_list .swiper-slide {
    width: 132px !important;
    max-width: 132px;
  }
  .ebook_list_text .swiper-slide:not(.swiper-slide-active) {
    opacity: 0 !important;
  }
  .event_banner_section .swiper-slide a {
    display: block;
    height: 100%;
    border-radius: 15px;
    border: 1px solid #727272;
  }
  .event_banner_section .swiper-slide a img {
    height: 100%;
    border-radius: 15px;
  }
}
</style>
